import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {getOfferTypeNameCapital} from "../../offer/helpers/OfferType";

const roomsPlural = pluralize(["pokój", "pokoje", "pokoi"]);

export const getPropertyPlanModalTitle = (property: {area: number; offer: {address: string; type: number}; rooms: number}) => {
    const propertyType = getOfferTypeNameCapital(property.offer.type);
    const rooms = `${property.rooms} ${roomsPlural(property.rooms)}`;
    const area = areaFormat(property.area);

    return `${propertyType}, ${property.offer.address} (${rooms}, ${area})`;
};

export const getPropertyPlanAltText = (offerName: string, property?: {area: number; number: string; offer: {address: string; type: number}; rooms: number}) => {
    if (!property) {
        return offerName;
    }
    const rooms = `${property.rooms} ${roomsPlural(property.rooms)}`;
    const area = areaFormat(property.area, {precision: 2});
    const type = `${getOfferTypeNameCapital(property.offer.type)} na sprzedaż`;
    return `Rzut - ${type} ${rooms} o powierzchni ${area} - numer ${property.number} w ${offerName}`;
};
import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {getOfferTypeNameCapital} from "../../offer/helpers/OfferType";

const roomsPlural = pluralize(["pokój", "pokoje", "pokoi"]);

export const getPropertyPlanModalTitle = (property: {area: number; offer: {address: string; type: number}; rooms: number}) => {
    const propertyType = getOfferTypeNameCapital(property.offer.type);
    const rooms = `${property.rooms} ${roomsPlural(property.rooms)}`;
    const area = areaFormat(property.area);

    return `${propertyType}, ${property.offer.address} (${rooms}, ${area})`;
};

export const getPropertyPlanAltText = (offerName: string, property?: {area: number; number: string; offer: {address: string; type: number}; rooms: number}) => {
    if (!property) {
        return offerName;
    }
    const rooms = `${property.rooms} ${roomsPlural(property.rooms)}`;
    const area = areaFormat(property.area, {precision: 2});
    const type = `${getOfferTypeNameCapital(property.offer.type)} na sprzedaż`;
    return `Rzut - ${type} ${rooms} o powierzchni ${area} - numer ${property.number} w ${offerName}`;
};
